document.addEventListener('DOMContentLoaded', () => {
    // Initialize every carousel inside a featured collection root
    const roots = document.querySelectorAll('.featured-collection--root');

    roots.forEach((root) => {
        const carousel = root.querySelector('.carousel');
        const container = root.querySelector('.carousel-container') || (carousel && carousel.parentElement);
        if (!carousel || !container) return;

        // Per-carousel state
        let isDragging = false;
        let startPositionX = 0;
        let currentTranslateX = 0;
        let previousTranslateX = 0;
        let currentX = 0;
        let moved = false;
        const MOVE_THRESHOLD = 8; // pixels

        // Initial styles and prevent native drag
        carousel.style.cursor = 'grab';
        carousel.addEventListener('dragstart', (e) => e.preventDefault());

        // Mouse events
        carousel.addEventListener('mousedown', dragStart);
        document.addEventListener('mousemove', dragging);
        document.addEventListener('mouseup', dragEnd);

        // Touch events
        carousel.addEventListener('touchstart', touchStart, { passive: true });
        document.addEventListener('touchmove', touchMove, { passive: false });
        document.addEventListener('touchend', dragEnd);

        let startPositionY = 0;
        let isVerticalScroll = false;

        function touchStart(e) {
            startPositionX = e.touches[0].clientX;
            startPositionY = e.touches[0].clientY;
            currentX = startPositionX;
            isVerticalScroll = false;
            dragStart(e);
        }

        function touchMove(e) {
            if (isVerticalScroll) return;

            const touchX = e.touches[0].clientX;
            const touchY = e.touches[0].clientY;
            
            // Calculate horizontal and vertical distance moved
            const deltaX = Math.abs(touchX - startPositionX);
            const deltaY = Math.abs(touchY - startPositionY);

            // If we haven't determined the direction yet
            if (!moved) {
                // If vertical movement is greater than horizontal, let the page scroll
                if (deltaY > deltaX && deltaY > MOVE_THRESHOLD) {
                    isVerticalScroll = true;
                    isDragging = false;
                    return;
                }
                
                // If horizontal movement is significant, prevent vertical scroll
                if (deltaX > MOVE_THRESHOLD) {
                    e.preventDefault();
                }
            }

            currentX = touchX;
            dragging(e);
        }

        function dragStart(e) {
            if (e.type === 'mousedown') {
                startPositionX = e.clientX;
                currentX = e.clientX;
            }

            isDragging = true;
            moved = false;
            carousel.style.cursor = 'grabbing';
            carousel.style.transition = 'none';
        }

        function dragging(e) {
            if (!isDragging) return;

            if (e.cancelable) e.preventDefault();

            const clientX = (e.touches && e.touches[0]) ? e.touches[0].clientX : (e.clientX || currentX);
            const diff = clientX - startPositionX;

            moved = Math.abs(diff) > MOVE_THRESHOLD;

            currentTranslateX = previousTranslateX + diff;

            const maxTranslate = 0;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            if (currentTranslateX > maxTranslate) currentTranslateX = maxTranslate;
            if (currentTranslateX < minTranslate) currentTranslateX = minTranslate;

            carousel.style.transform = `translateX(${currentTranslateX}px)`;
        }

        function dragEnd() {
            if (!isDragging) return;

            isDragging = false;
            carousel.style.cursor = 'grab';
            carousel.style.transition = 'transform 0.3s ease-out';

            // Snap to nearest item on drag end
            const firstItem = carousel.querySelector('.carousel-item');
            const gap = parseInt(getComputedStyle(carousel).gap || '10', 10) || 10; // fallback 10px
            const itemWidth = firstItem ? firstItem.offsetWidth : Math.floor((container.offsetWidth - gap) / 2);
            const step = itemWidth + gap;

            // compute closest index
            const rawIndex = Math.round(Math.abs(currentTranslateX) / step);
            const targetTranslate = -rawIndex * step;

            const maxTranslate = 0;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            // clamp target
            const finalTranslate = Math.min(maxTranslate, Math.max(minTranslate, targetTranslate));

            currentTranslateX = finalTranslate;
            previousTranslateX = currentTranslateX;

            // apply snapping transform
            carousel.style.transform = `translateX(${currentTranslateX}px)`;

            if (moved) {
                // keep moved true briefly so the following click can be suppressed
                setTimeout(() => { moved = false; }, 200);
            }
            // update arrows opacity/state after snapping
            updateButtonsVisibility();
        }

        // Navigation buttons (per carousel)
        // Check if buttons already exist in this container
        let prevButton = container.querySelector('.navigation-button.prev-button');
        let nextButton = container.querySelector('.navigation-button.next-button');

        // Only create buttons if they don't exist
        if (!prevButton) {
            prevButton = document.createElement('button');
            prevButton.className = 'navigation-button prev-button';
            prevButton.innerHTML = '←';
            container.appendChild(prevButton);
        }

        if (!nextButton) {
            nextButton = document.createElement('button');
            nextButton.className = 'navigation-button next-button';
            nextButton.innerHTML = '→';
            container.appendChild(nextButton);
        }

        prevButton.addEventListener('click', () => {
            // move by one item width + gap
            const firstItem = carousel.querySelector('.carousel-item');
            const gap = parseInt(getComputedStyle(carousel).gap || '10', 10) || 10;
            const itemWidth = firstItem ? firstItem.offsetWidth : Math.floor((container.offsetWidth - gap) / 2);
            const moveAmount = itemWidth + gap;

            currentTranslateX = Math.min(currentTranslateX + moveAmount, 0);
            carousel.style.transition = 'transform 0.3s ease-out';
            carousel.style.transform = `translateX(${currentTranslateX}px)`;
            previousTranslateX = currentTranslateX;
            updateButtonsVisibility();
        });

        nextButton.addEventListener('click', () => {
            const firstItem = carousel.querySelector('.carousel-item');
            const gap = parseInt(getComputedStyle(carousel).gap || '10', 10) || 10;
            const itemWidth = firstItem ? firstItem.offsetWidth : Math.floor((container.offsetWidth - gap) / 2);
            const moveAmount = itemWidth + gap;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            currentTranslateX = Math.max(currentTranslateX - moveAmount, minTranslate);
            carousel.style.transition = 'transform 0.3s ease-out';
            carousel.style.transform = `translateX(${currentTranslateX}px)`;
            previousTranslateX = currentTranslateX;
            updateButtonsVisibility();
        });

        // Buttons are now added when created above

        // helper: toggle disabled class on arrows when at ends
        function updateButtonsVisibility() {
            const maxTranslate = 0;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            if (currentTranslateX >= -1) {
                prevButton.classList.add('disabled');
                prevButton.setAttribute('aria-disabled', 'true');
            } else {
                prevButton.classList.remove('disabled');
                prevButton.setAttribute('aria-disabled', 'false');
            }

            if (currentTranslateX <= minTranslate + 1) {
                nextButton.classList.add('disabled');
                nextButton.setAttribute('aria-disabled', 'true');
            } else {
                nextButton.classList.remove('disabled');
                nextButton.setAttribute('aria-disabled', 'false');
            }
        }

        // initial state
        updateButtonsVisibility();

        // Suppress anchor clicks when a drag occurred (capture phase)
        root.addEventListener('click', (e) => {
            const anchor = e.target.closest && e.target.closest('a');
            if (!anchor) return;
            if (moved) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }, true);
    });
});